import React from 'react';
import {
	Box,
	Button,
	Dialog,
	DialogContent,
	Typography,
	DialogActions,
	useMediaQuery,
	useTheme,
} from '@mui/material';
import DialogHeader from 'common/components/dialog/DialogHeader';
import { push, Routes } from 'routing';
import { useTranslation } from 'services/localization';
import { useLocation } from 'react-router-dom';
import FeatureButton from '../FeatureButton';

export interface MultipleStoresPromoDialogProps {
	open: boolean;
	onClose: () => void;
}
const MultipleStoresPromoDialog = (props: MultipleStoresPromoDialogProps) => {
	const { open, onClose } = props;
	const { t } = useTranslation();
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
	const { pathname } = useLocation();

	return (
		<Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" fullScreen={isSmallScreen}>
			<DialogHeader
				title={t('promoPages.multipleStores.title', 'This feature is part of Rentle Basic')}
				variant="info"
			/>
			<DialogContent sx={{ mt: 4, mb: 2, px: 4 }}>
				<Typography variant="h5" sx={{ mb: 2 }}>
					{t('promoPages.multipleStores.header', 'Multiple stores')}
				</Typography>
				<Typography variant="body1">
					{t(
						'promoPages.multipleStores.body',
						'Operate a multi-location business on top of Rentle by upgrading to Rentle Basic. Each store can have its own catalog, inventory, users and more.',
					)}
				</Typography>

				<Box
					sx={{
						mt: 4,
						background: theme.palette.background.default,
						p: 3,
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						alignItems: 'center',
						flexWrap: 'wrap',
					}}
				>
					<FeatureButton
						variant="contained"
						sx={{ m: 1 }}
						onClick={() => {
							push(Routes.PLANS, { from: pathname });
							onClose();
						}}
						requiredFeature="PLAN_BILLING"
					>
						{t('account.stores.upgradePlan')}
					</FeatureButton>
					<Button
						variant="outlined"
						sx={{ m: 1 }}
						onClick={() => {
							window.open('https://www.rentle.io/demo', '_blank');
							onClose();
						}}
					>
						{t('homeView.bookADemo')}
					</Button>
				</Box>
			</DialogContent>
			<DialogActions sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', pb: 3 }}>
				<Button color="secondary" onClick={onClose}>
					{t('common:actions.close')}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default MultipleStoresPromoDialog;
